/**
 * 我的找样item
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2024/6/13      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import dayjs from "dayjs";
import "./index.less";
class Item extends React.Component{
    constructor(props) {
        super(props);
    }

    openDetail(item){
        window.open(`/customer/fuzzy-detail?id=${item.id}`,'_self');
    }

    getStatusHtml(item){
        if(item.status=='15'){
            return <div className="status-label status-label15">
                {__getServerLanguage('ZhaoYangZhong')}
            </div>
        }else if(item.status=='20'){
            return <div className="status-label status-label20">
                {__getServerLanguage('YouZhaoDao')}
            </div>
        }else if(item.status=='50'){
            return <div className="status-label status-label50">
                {__getServerLanguage('RenWuWanCheng')}
            </div>
        }else if(item.status=='40'){
            return <div className="status-label status-label40">
                {__getServerLanguage('YiQuXiao')}
            </div>
        }
        return null;
    }

    getTipHtml(item){
        if(item.status=='15'){
            return <div className="color045 font_14 lineH_150p mt_4">{__getServerLanguage('PinLeiJingLiZhengZaiWeiNi')}</div>
        }else if(item.status=='20'){
            return <div >
                {
                    item.isNew?
                        <i className="red-dot"></i>
                        :
                        null
                }
                <span className="color066 font_14 lineH_150p">
                    {/*{item.newReplyTime?dayjs(item.newReplyTime).format('MM-DD'):'-'} 有更新，共找到 {item.skuNum} 款*/}
                    {__getServerLanguage('YouGengXinGongZhaoDaoKuan',item.newReplyTime?dayjs(item.newReplyTime).format('MM-DD'):'-',item.skuNum)}
                </span>
            </div>
        }else if(item.status=='50'){
            if(item.skuNum>0){
                return <div className="flex-box">
                    <img className="emoji" src="https://oss.essaone.com/f267ccb0-d014-479b-a6a3-da6c6761fcb3.png" alt=""/>
                    <span className="color066 font_14 lineH_150p">
                        {/*{item.effectiveEndTime} 已全部找完，共找到 {item.skuNum} 款*/}
                        {__getServerLanguage('YiQuanBuZhaoWanGongZhaoDa',item.effectiveEndTime?dayjs(item.effectiveEndTime).format('MM-DD'):'-',item.skuNum)}
                    </span>
                </div>
            }else{
                return <div className="color066 font_14 lineH_150p">{__getServerLanguage('BaoQianWoMenMeiYouZhaoDao')}</div>
            }
        }else if(item.status=='40'){
            return <div className="color045 font_14 lineH_150p">{item.lastUpdateTime?dayjs(item.lastUpdateTime).format('MM-DD'):'-'} {__getServerLanguage('QuXiao')}</div>;
        }else{
            return null;
        }
    }


    render(){
        let {item={}} = this.props;
        let file = {};
        if(item.fileList&&item.fileList.length>0){
            file = item.fileList[0];
        }
        return (
            <div className="fuzzy-item__wrap" onClick={this.openDetail.bind(this,item)}>
                {
                    file.url?
                        <img src={file.url} className="img" alt=""/>
                        :
                        <img src="http://oss.essa.cn/04d1ca90-811f-4d61-96d4-ada86e4bfedb.svg" className="img" alt=""/>
                }
                <div className="flex-1">
                    {
                        item.subject?
                            <div className="content mb_4" title={item.subject}>{item.subject}</div>
                            :
                            null
                    }
                    {this.getTipHtml(item)}
                    {
                        item.isNewMessage?
                            <div className="color_FB7321 mt_4 lineH_150p font_14">
                                {__getServerLanguage('ShangPinJingLiHuiFuLeXinD')}
                            </div>:null
                    }
                    <div className="mt_4">
                        {this.getStatusHtml(item)}
                    </div>
                </div>
                <div className="ml_60 lineH_150p text-right no-wrap">
                    <div className="color066 font_14">{item.createTime?dayjs(item.createTime).format('YYYY-MM-DD'):'-'}</div>
                    <div className="color033 font_12">#{item.id}</div>
                </div>
            </div>
        )
    }
}

Item.defaultProps = {
}

Item.propTypes = {

}
export default Item;
